import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import Panel from "@ui/panel/Panel";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { FormParser } from "../FormParser";

export const AcquirerChannelEditor = () => {
	useLocale();
	const editorRequestData = GD.S_ACQUIRER_CHANNEL_EDITOR.use();
	const [busy, setBusy] = useState<boolean>();

	useEffect(() => {
		if (!editorRequestData || !editorRequestData.acquirerID) return;
	}, [editorRequestData]);

	if (!editorRequestData) return null;

	const closePopup = () => {
		GD.S_ACQUIRER_CHANNEL_EDITOR.invoke(null);
	};

	const onSuccess = () => {
		GD.S_CHANNELS_UPDATE.invoke({});
		closePopup();
	};

	return (
		<Panel
			sx={{
				maxWidth: "auto",
				minWidth: "400px",
				maxHeight: "90vh",
			}}
			disableScroll
			growContent
			decorator="absolute"
			busy={busy}
			label={msg("payMethodChannel")}
			onClose={closePopup}>
			<FormParser
				key="acquirerChannelEditor"
				onSubmit={async data => {
					// submit
					setBusy(true);
					const result = await GD.REQ_API.request({
						method: "channels/add",
						data: data,
					});
					setBusy(false);
					return result;
				}}
				onRequest={async () => {
					setBusy(true);
					const result = await GD.REQ_API.request({
						method: "channels/get",
						data: {
							id: editorRequestData.channel,
							acquirer_id: editorRequestData.acquirerID,
						},
					});
					setBusy(false);
					return result;
				}}
				onComplete={onSuccess}
			/>
		</Panel>
	);
};
